<template>
  <div
    class="modal fade"
    id="foodModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            <img src="../assets/ico-lapide.svg" /> Materia prima
          </h5>
          <button
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            ref="closeButton"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body">
          <form>
            <label>Barracão: {{barnName}}</label><br />

            <div class="tabs">
                <div class="tab tab-register" :class="change ? 'active' : ''"  @click="changeTab('change')">
                Trocar
                </div>
                <div class="tab" @click="changeTab('register')" :class="register ? 'active' : ''">
                Cadastrar
                </div>
            </div>
            <div>
                <div class="form-changed"  v-if="change">
                <!-- <label>Food: </label><br /> -->
                <select name="" class="form-control" id="" v-model="optionFood">
                    <option>Rações</option>
                    <option v-for="row in foodSelectOptions" :key="row.pk" :value="row.food">{{ row.label }}</option>
                </select>

                <!-- <label>Silo: </label><br /> -->
                <select name="" class="form-control" id="" v-model="optionSilo">
                    <option>Silos</option>
                    <option v-for="silo in silosData" :key="getSiloId(silo)" :value="silo">{{ siloDisplayName(silo) }}</option>
                </select>

                <!-- <label>Data e Hora:</label><br /> -->
                <input
                type="date"
                class="form-control"
                v-model="date"

                required
                />
            </div>
            <div class="form-register" v-if="register">
                <!-- <label>Nova Ração: </label><br /> -->
                <input
                    type="text"
                    class="form-control"
                    placeholder="Food"
                    v-model="name"
                    required
                />

                <!-- <label>Densidade: </label><br /> -->
                <input
                    type="number"
                    class="form-control"
                    placeholder="Densidade"
                    v-model="density"
                    required
                />
                <div class="checkbox-items">
                    <div class="silo-checkbox" v-for="(silo) in silosData" :key="getSiloId(silo)">
                        <label>
                            <input
                                type="checkbox"
                                v-model="checkedItems[getSiloId(silo)]"
                            />
                            {{ siloDisplayName(silo) }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="container-button">
                <button v-if="!isLoading" type="submit" class="modal-btn" @click="send">{{register ? 'Cadastrar' : 'Trocar'}}</button>
                <MiniLoader v-else />
            </div>
            </div>
            
          </form>
        </div>
      </div>
    </div>
    <SuccessAlert ref="successAlert" v-bind:message="messageSuccess"/>
    <ErrorAlert ref="errorAlert" v-bind:message="messageFailure"/>
  </div>
  <!-- end Cadastrar Baixa  -->
</template>

<script>
import ErrorAlert from "./ErrorAlert.vue";
import SuccessAlert from "./SuccessAlert.vue";
import MiniLoader from "./MiniLoader.vue";

function foodOptionDisplayLabel(food) {
  if (!food || !food.name) return ''
  const pk = food.pk ?? food.id ?? null
  const density = Number(food.density)
  const parts = [pk, food.name].filter((part) => part != null && part !== '')
  if (Number.isFinite(density) && density > 0) {
    const formatted = density.toLocaleString('pt-BR', {
      minimumFractionDigits: density % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    })
    parts.push(`${formatted} kg/m³`)
  }
  return parts.join(' - ')
}

function getSiloId(item) {
  return item?.silo?.pk ?? item?.silo?.id ?? item?.silo ?? null
}

function siloDisplayName(silo) {
  if (!silo) return ''
  const id = getSiloId(silo)
  return silo.silo_name || silo.name || (id != null ? `Silo ${id}` : 'Silo sem nome')
}

export default {
  name: "LossModal",
  components: {
    ErrorAlert,
    SuccessAlert,
    MiniLoader
  },
  props: ['selectedFeed', 'allFood'],
  data() {
    return {
        name: '',
        density: '',
        silos:[],
        date: new Date().toISOString().substr(0, 10),
        optionFood: "Rações",
        optionSilo: "Silos",
        register: false,
        change: true,
        checkedItems: {},
        isLoading: false,
        messageSuccess: "Cadastro realizado com sucesso",
        messageFailure: "Error ao cadastrar a ração",
    }
  },
  methods: {
    getSiloId,
    siloDisplayName,
    showSuccessAlert() {
      this.$refs.successAlert.alert()
      setTimeout(() => {
        this.$refs.successAlert.closeAlert()
      }, 3000)
    },
    async registerFood(name, density, silos, company) {
        this.isLoading = true;
        const selectedSilos = Object.keys(silos)
        .filter(id => silos[id])
        .map(Number);
      await this.$store.dispatch("registerFood", {name, density, selectedSilos, company})
      this.isLoading = false;
      if (!(this.$store.getters.getError)) {
        this.$refs.errorAlert.closeAlert()
        this.$refs.successAlert.alert()
        this.handleClose()
      }
      else {
        this.messageFailure = "Error ao cadastrar a ração";
        this.$refs.successAlert.closeAlert()
        this.$refs.errorAlert.alert()
      }
    },
    async changeFood(foodOption, company, date, siloOption) {
        this.isLoading = true;
      const food = foodOption?.pk
      const silo = getSiloId(siloOption)
      const foodName = foodOption?.name ?? "selecionado"
      const newDate = `${date}T00:00:00.000`  
       
      await this.$store.dispatch("changeFood", {food, company, newDate, silo})
      this.isLoading = false;
      if (!(this.$store.getters.getError)) {
        this.messageSuccess = `Food "${foodName}" trocado com sucesso`;
        this.messageFailure = "Error ao trocar a ração";
        this.$refs.errorAlert.closeAlert()
        this.handleClose()
        this.showSuccessAlert()
      }
      else {
        this.messageFailure = "Error ao trocar a ração";
        this.$refs.successAlert.closeAlert()
        this.$refs.errorAlert.alert()
      }
    },
    handleClose() {
      this.$refs.closeButton.click();
    },
    changeTab(value){
        if (value == 'register') {
            this.register = true
            this.change = false
        } else {
            this.register = false
            this.change = true
        }
    },
    send (event) {
        event.preventDefault()
        if (this.change) {
            this.changeFood(this.optionFood, this.company, this.date, this.optionSilo)
        }else {
            this.registerFood(this.name, this.density, this.checkedItems, this.company)
        }
    },
  },
  computed: {
    foodSelectOptions() {
      const foods = Array.isArray(this.allFood) ? this.allFood : []
      return foods.map((food) => ({
        pk: food.pk,
        food,
        label: foodOptionDisplayLabel(food)
      }))
    },
    barnName() {
      if (this.barn == null) return ""
      return `${this.barn.name}`
    },
    barn() {
      return this.$store.getters.getBarnTarget
    },
    batch() {
      return this.$store.getters.getBatchTarget
    },
    farm() {
      return this.$store.getters.getAllBarns.find((obj)=> {
        return obj.barn.find((barn)=>barn.pk == this.barn.pk)
      })
    },
    company() {
      return this.farm?.farm?.company
    },
    silosData() {
      const raw = Array.isArray(this.selectedFeed?.data) ? this.selectedFeed.data : []
      if (raw.length === 0) return []

      const siloGroups = {}
      raw.forEach((item) => {
        const id = getSiloId(item)
        if (id == null) return
        if (!siloGroups[id]) siloGroups[id] = []
        siloGroups[id].push(item)
      })

      const unique = Object.values(siloGroups).map((group) => {
        if (group.length === 1) return group[0]
        return group.find((s) => s.virtual) || group[0]
      })

      return unique.sort((a, b) => {
        const nameA = siloDisplayName(a)
        const nameB = siloDisplayName(b)
        return nameA.localeCompare(nameB, undefined, { numeric: true, sensitivity: 'base' })
      })
    }
  },
  created() {
    this.silosData.forEach((item) => {
      this.$set(this.checkedItems, getSiloId(item), true)
    })
  }
}
</script>

<style scoped>
.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
  padding-left: 10px;
}

select {
  margin: 0px;
  margin-top: 5px;
  padding-left: 0px;
}

.modal-body select {
  padding-left: 6px;
}

.modal-body label {
  padding-left: 12px;
}

.tabs {
  display: flex;
  border-radius: 5px;
  margin-top: 12px ;
}

.tab {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-right: 5px;
  background-color: #e0e0e0;
  border-radius: 3px;
  cursor: pointer;
  border-top-right-radius: 8px;
  width: 50%;
}

.tab i {
  margin-right: 5px;
}

.tab:active {
  background-color: #c0c0c0;
}

.form-changed {
    margin-top: 24px;
    margin-bottom: 24px;
}

.form-register {
    margin-top: 24px;
    margin-bottom: 24px;
}

.form-control{
    margin-top: 12px;
}

.checkbox-items {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 8px;
  margin-top: 15px;
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
}

.silo-checkbox {
  display: flex;
  align-items: center;
  height: 48px;
}

.silo-checkbox label {
  display: flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  padding: 6px 8px;
  border-radius: 4px;
  background-color: #f8f9fa;
  width: 100%;
  height: 100%;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 12px;
  white-space: normal;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.2;
}

.silo-checkbox label:hover {
  background-color: #e9ecef;
}

.silo-checkbox input[type="checkbox"] {
  margin: 0;
  cursor: pointer;
  transform: scale(0.9);
  flex-shrink: 0;
  align-self: flex-start;
  margin-top: 4px;
}

.active{
    color: white;
    background-color: #78b843;
}

.container-button{
    display: flex;
    justify-content: end;
    align-items: center;
    min-height: 40px;
}
</style>
